import CommonTable from "../../Helpers/CommonTable";
import { redPana } from "../JodiCharts/Chart.config";
import { Eight } from "./Chart.config";

const ShreeDevi = ({ chartData }) => {

  return (
    <CommonTable
      staticData={Eight}
      chartData={chartData}
      redJodi={redPana.map((j) => parseInt(j))}
    />
  );
};

export default ShreeDevi;
